module.exports = __webpack_public_path__ + "svg/setting.9bd0be274ade7b284bf52ac75ef33fe6.svg";